import { Cookie } from './cookie'

export const cookieKey = `mv_tokens`

export class MvUUID extends Cookie<IMVToken> {
  constructor(name = cookieKey) {
    super({ name })
  }

  get id(): string | undefined {
    return this.value?.mv_uuid
  }

  get version() {
    return this.value?.version
  }
}

export const mvUUID = new MvUUID()
